import React, {useRef, useState} from 'react'
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import store from "../../reducers/createReducers";
import {useEffect} from "react";
import AUTHENTICATION_ACTIONS from "../../actions/authentication-actions";
import {useSelector} from "react-redux";
import InstrumentIcon from "../instrument-icon";
import {useTranslation} from "react-i18next";
import Big from "big.js";
import Notifications from "../notifications";
import SvgIcon from "../svg-icon";
import associateServices from "../../services";
import './index.css'
import {Tooltip} from "react-tooltip";
import {show} from "@intercom/messenger-js-sdk";
import stringHelper from "../../helpers/string-helper";
import {toast} from "react-toastify";
import InformationToast from "../toast/InformationToast";
import {Director, Publish} from "@millicast/sdk";
import Draggable from "react-draggable";
import {broadcastReduxState} from "../../utils/broadcast";
import SpriteSvg from "../../assets/svg/sprite.svg";
import WheelIcon from "../wheel-icon";


const Header = () => {

    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const {
        currencyList,
        selectedWallet,
        hideZeroBalances,
        authenticated,
        selectedFiat,
        fiatRates,
        user
    } = useSelector(state => state.authenticationReducer)

    const {inPlay, agent, symbols, activeLanguage, configuration} = useSelector(state => state.globalReducer)

    const navigate = useNavigate()
    const [filteredCurrencyList, setFilteredCurrencyList] = useState([])
    const [searchParams, setSearchParams] = useSearchParams()
    const [search, setSearch] = useState('')

    const [hasUnreadNotifications, setHasUnReadNotifications] = useState({
        notifications: 0,
        messages: 0,
    })

    const canvasRef = useRef(null);
    const pcRef = useRef(null);
    const screenStreamRef = useRef(null);
    const micStreamRef = useRef(null);
    const camStreamRef = useRef(null);

    const [isProcessing, setIsProcessing] = useState(false);
    const [isStreaming, setIsStreaming] = useState(false);
    const [streamName, setStreamName] = useState(null);
    const [cameraSize] = useState({width: 400, height: 300});
    const [cameraPosition] = useState({x: 20, y: 20});
    const [discountSubmitting, setDiscountSubmitting] = useState(false)

    const location = useLocation()

    const [cameraEnabled, setCameraEnabled] = useState(true);
    const [cameraMicEnabled, setCameraMicEnabled] = useState(true);
    const [tabAudioEnabled, setTabAudioEnabled] = useState(true);

    const camVideoTrackRef = useRef(null);
    const camAudioTrackRef = useRef(null);
    const tabAudioTrackRef = useRef(null);
    const micAudioTrackRef = useRef(null); // ✅ Real mic (used in stream)
    const mixedAudioStreamRef = useRef(null);


    useEffect(() => {
        if (agent?.isMobile) {
            setTimeout(() => {
                window?.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            }, 250)
        } else {
            const dov = document.getElementById('main__content')
            setTimeout(() => {
                dov?.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            }, 250)
        }

    }, [location?.pathname, location?.search, agent?.isMobile])


    useEffect(() => {
        const latestWallet = localStorage.getItem('wallet', selectedWallet?.code);
        if (latestWallet && selectedWallet?.code !== latestWallet) {
            const item = currencyList?.find(ii => ii.code === latestWallet)
            if (item)
                store.dispatch(AUTHENTICATION_ACTIONS.setActiveWallet(item))
        }
    }, [currencyList])

    useEffect(() => {

        hideZeroBalances ? setFilteredCurrencyList(
            currencyList?.filter(i => parseFloat(i.balance) > 0).filter(i => i?.name?.toUpperCase()?.includes(search?.toUpperCase()) || i?.code?.toUpperCase()?.includes(search?.toUpperCase()))
                .sort((a, b) => b.balance - a.balance)
        ) : setFilteredCurrencyList(
            currencyList.filter(i => i?.name?.toUpperCase()?.includes(search?.toUpperCase()) || i?.code?.toUpperCase()?.includes(search?.toUpperCase()))
                .sort((a, b) => b.balance - a.balance)
        )
    }, [currencyList, search, hideZeroBalances])

    useEffect(() => {
        registerListener()
    }, [activeLanguage?.key])

    useEffect(() => {
        const multisearch = document.querySelector('.main__search-drop');
        multisearch?.classList?.remove('main__search-drop--active');

        var mainSearch = document.querySelector('.main__search');
        mainSearch?.classList?.remove('active')

        setSearch('')
    }, [location?.pathname])


    const [correction, setCorrection] = useState({})
    useEffect(() => {
        if (!authenticated || !selectedWallet?.code) return;

        associateServices.checkCorrection({
            code: selectedWallet.code
        }).then(res => {
            if (res?.data && parseFloat(res?.data?.required_wager || 0) > 0) {
                let dt = res?.data
                const percentage = parseFloat(Big(res?.data?.wagered_currency || res?.data?.wagered || 0).div(res?.data?.required_wager_currency || res?.data?.required_wager || 1)
                    .times(100).toFixed(2))

                if (parseFloat(percentage || 0) >= 100) {

                } else {
                    dt.percentage = percentage
                    setCorrection(dt)
                }
            } else {
                setCorrection({})
                clearInterval(interval);
            }
        });

        const interval = setInterval(() => {
            associateServices.checkCorrection({
                code: selectedWallet.code
            }).then(res => {
                if (res?.data && parseFloat(res?.data?.required_wager || 0) > 0) {
                    let dt = res?.data
                    const percentage = parseFloat(Big(res?.data?.wagered_currency || res?.data?.wagered || 0).div(res?.data?.required_wager_currency || res?.data?.required_wager || 1)
                        .times(100).toFixed(2))

                    if (parseFloat(percentage || 0) >= 100) {

                    } else {
                        dt.percentage = percentage
                        setCorrection(dt)
                    }
                } else {
                    setCorrection({})
                    clearInterval(interval);
                }
            });
        }, 20000); // 20 seconds

        return () => clearInterval(interval);

    }, [authenticated, selectedWallet?.code]);

    const handleRegister = () => {
        searchParams.set('modal', 'register')
        setSearchParams(searchParams)
    }
    const handleLogin = () => {
        searchParams.set('modal', 'login')
        setSearchParams(searchParams)
    }

    const handleLogout = () => {
        associateServices.logout({}).then(res => store.dispatch(AUTHENTICATION_ACTIONS.setUserLogOut(null)))

        navigate(stringHelper.getLocalizedPath(currentLanguage, '/'))
    }

    const handleWheel = () => navigate(stringHelper.getLocalizedPath(currentLanguage, '/wheel'))

    const registerListener = () => {

        if (document.querySelector('.header')) {
            const headerBtn = document.querySelector('.header__btn');
            const headerBar = document.querySelector('.header__bar');
            const headerNav = document.querySelector('.sidebar');
            const main = document.querySelector('.main');
            const footer = document.querySelector('.footer');

            var sidebar = document.querySelector('.sidebar');

            var screenWidth = window.innerWidth;
            var mainContent = document.querySelector('.main__content');
            var footerContent = document.querySelector('.footer__content');

            function toggleHeaderMenu() {
                if (screenWidth >= 1320) {
                    const width = mainContent.offsetWidth;
                    mainContent.style.width = width + 'px';

                    footerContent.style.width = width + 'px';
                } else {
                    mainContent.style.width = '';
                    footerContent.style.width = '';
                }


                // const body = document.body
                // if (headerNav?.classList?.contains('sidebar--active')) {
                //     body.classList.add('no-scroll')
                // } else {
                //     body.classList.remove('no-scroll')
                // }


                headerBtn?.classList?.toggle('header__btn--active');
                headerBar?.classList?.toggle('header__bar--active');
                headerNav?.classList?.toggle('sidebar--active');
                main?.classList?.toggle('main--active');
                footer?.classList?.toggle('footer--active');
            }

            headerBtn?.addEventListener('click', toggleHeaderMenu);

            if (document.querySelector('.lowbar__btn--menu')) {
                var lowbarMenuBtn = document.querySelector('.lowbar__btn--menu');

                lowbarMenuBtn?.addEventListener('click', toggleHeaderMenu);

                document?.addEventListener('click', function (event) {
                    if (sidebar?.classList?.contains('sidebar--active') && screenWidth < 1200) {
                        var isClickInside01 = sidebar?.contains(event.target);
                        var isClickButton01 = headerBtn?.contains(event.target);
                        var isClickButton02 = lowbarMenuBtn?.contains(event.target);

                        if (!isClickInside01 && !isClickButton01 && !isClickButton02) {
                            sidebar?.classList?.remove('sidebar--active');

                        }
                    }
                });
            } else {
                document?.addEventListener('click', function (event) {
                    if (sidebar?.classList?.contains('sidebar--active') && screenWidth < 1200) {
                        var isClickInside01 = sidebar?.contains(event.target);
                        var isClickButton01 = headerBtn?.contains(event.target);

                        if (!isClickInside01 && !isClickButton01) {
                            sidebar?.classList?.remove('sidebar--active');

                        }
                    }
                });
            }
        }


        // var multisearch = document.querySelector('.main__search-drop');
        // var mainSearch = document.querySelector('.main__search');
        // var headerSearchBtn = document.querySelector('.header__search-btn');
        // // var headerSearchBtnMob = document.querySelector('.header__search-btnmob');
        // var multisearchClose = document.querySelector('.multisearch__close');
        //
        // function toggleSearch() {
        //     if (!multisearch?.classList?.contains('main__search-drop--active')) {
        //         mainSearch?.classList?.add('active')
        //     } else {
        //         mainSearch?.classList?.remove('active')
        //         setSearch('')
        //
        //     }
        //
        //     multisearch?.classList?.toggle('main__search-drop--active');
        // }
        //
        // headerSearchBtn?.addEventListener('click', toggleSearch);
        // // headerSearchBtnMob?.addEventListener('click', toggleSearch);
        // multisearchClose?.addEventListener('click', toggleSearch);


        // if (document.querySelector('.main__search-drop')) {
        //     var multisearch = document.querySelector('.main__search-drop');
        //     var headerSearchBtn = document.querySelector('.header__search-btn');
        //     var headerSearchBtnMob = document.querySelector('.header__search-btnmob');
        //
        //     // var multisearchClose = document.querySelector('.multisearch__close');
        //
        //     function toggleSearch() {
        //         multisearch?.classList?.toggle('main__search-drop--active');
        //     }
        //
        //     headerSearchBtn?.addEventListener('click', toggleSearch);
        //     headerSearchBtnMob?.addEventListener('click', toggleSearch);
        //     // multisearchClose?.addEventListener('click', toggleSearch);
        //
        //     document?.addEventListener('click', function (event) {
        //         if (multisearch?.classList?.contains('main__search-drop--active')) {
        //             var isClickInside = multisearch?.contains(event.target);
        //             var isClickButton = headerSearchBtn?.contains(event.target) || headerSearchBtnMob?.contains(event.target);
        //
        //             if (!isClickInside && !isClickButton) {
        //                 multisearch?.classList?.remove('main__search-drop--active');
        //             }
        //         }
        //     });
        // }

    }

    const handleLiveSupport = () => {

        if (window?.Comm100API) {
            try {
                console.log('window?.Comm100API = ', window?.Comm100API)
                window?.Comm100API?.open_chat_window();
            } catch (e) {
                console.error(e)
            }
        } else {
            try {
                show()
            } catch (e) {
                console.error(e)
                alert(e.message)
            }
        }

    }

    const handleReFetchNotifications = () => setHasUnReadNotifications(0)
    useEffect(() => {
        if (authenticated) {
            associateServices.checkNotifications({}).then(res => {

                setHasUnReadNotifications(prevState => ({
                    ...prevState,
                    notifications: res?.data
                }))


                associateServices.checkMessages({}).then(response => {
                    setHasUnReadNotifications(prevState => ({
                        ...prevState,
                        messages: response?.data
                    }))
                })
            })


        }
    }, [authenticated])

    const handleDiscountCheck = () => {

        if (discountSubmitting)
            return false
        setDiscountSubmitting(true)

        associateServices.claimWalletDiscount({
            code: selectedWallet.code
        }).then(res => {
            setDiscountSubmitting(false)

            if (res?.status !== 200)
                return toast(<InformationToast
                    title={t(`general.information`)}
                    message={t(`api-notifications.${res?.errors}`)}
                />)

            const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))
            associateServices.getWallets({}).then(handleUserWallets)


            toast(<InformationToast
                message={t(`api-notifications.discount-claimed-message`)}
                title={t(`api-notifications.discount-claimed-title`)}
            />)
        })
    }


    const checkIfVP9InUse = async (pc) => {
        const stats = await pc.getStats();

        let vp9Found = false;

        stats.forEach(report => {
            // Check outbound video stream
            if (report.type === 'outbound-rtp' && report.kind === 'video' && report.codecId) {
                const codec = stats.get(report.codecId);
                if (codec?.mimeType?.toLowerCase().includes('vp9')) {
                    vp9Found = true;
                    console.log('✅ VP9 is in use for video streaming.');
                } else {
                    console.warn('⚠️ Video codec in use is not VP9:', codec?.mimeType);
                }
            }

            // Optional: log all codec info
            if (report.type === 'codec') {
                console.log(`[Codec] PT: ${report.payloadType}, Type: ${report.mimeType}`);
            }
        });

        if (!vp9Found) {
            console.warn('❌ VP9 is not being used. Your browser may have fallen back to VP8 or H264.');
        }
    };


    function mixAudioStreams(streams) {
        const context = new AudioContext();
        const destination = context.createMediaStreamDestination();

        streams.forEach(s => {
            s.getAudioTracks().forEach(track => {
                const source = context.createMediaStreamSource(new MediaStream([track]));
                source.connect(destination);
            });
        });

        return destination.stream;
    }

    const boostMicFromStream = (stream, boostFactor = 2.0) => {
        const track = stream.getAudioTracks()[0];
        if (!track) return null;

        const ctx = new AudioContext();
        const source = ctx.createMediaStreamSource(new MediaStream([track]));
        const gain = ctx.createGain();
        gain.gain.value = boostFactor;

        const destination = ctx.createMediaStreamDestination();
        source.connect(gain).connect(destination);
        return destination.stream;
    };


    const startStream = async () => {
        if (isProcessing) return false;


        setIsProcessing(true);

        const {streamName, jwt, id} = await associateServices.checkStream().then(res => res.data);
        if (!streamName || !jwt || !id) return false;

        setIsStreaming(true);

        store.dispatch(AUTHENTICATION_ACTIONS.setStreamID(id));
        broadcastReduxState('activeStreamID', id);
        setStreamName(streamName);

        // 1. Capture screen with tab audio
        const screenStream = await navigator.mediaDevices.getDisplayMedia({
            video: {
                width: {ideal: 1920},
                height: {ideal: 1080},
                frameRate: {ideal: 30, max: 60}
            },
            audio: true
        });

        const tabAudioTrack = screenStream.getAudioTracks()[0];
        if (tabAudioTrack) {
            tabAudioTrackRef.current = tabAudioTrack;
            setTabAudioEnabled(tabAudioTrack.enabled);
        }

        // 2. Capture real microphone and boost it
        const micStream = await navigator.mediaDevices.getUserMedia({audio: true});
        const boostedMicStream = boostMicFromStream(micStream, 2.0); // ← Boost volume x2
        const boostedMicTrack = boostedMicStream?.getAudioTracks()[0];
        if (boostedMicTrack) {
            micAudioTrackRef.current = boostedMicTrack;
            setCameraMicEnabled(boostedMicTrack.enabled);
        }

        // 3. Webcam capture (for overlay only)
        const camStream = await navigator.mediaDevices.getUserMedia({
            video: {width: {ideal: 640}, height: {ideal: 480}, frameRate: {ideal: 30}},
            audio: true
        });

        const camVideoTrack = camStream.getVideoTracks()[0];
        if (camVideoTrack) {
            camVideoTrackRef.current = camVideoTrack;
            setCameraEnabled(camVideoTrack.enabled);
        }

        const camAudioTrack = camStream.getAudioTracks()[0];
        if (camAudioTrack) {
            camAudioTrackRef.current = camAudioTrack; // not used but can be toggled
        }

        // 4. Setup video elements
        const screenVideo = document.createElement('video');
        screenVideo.srcObject = screenStream;
        await screenVideo.play();

        const camVideo = document.createElement('video');
        camVideo.srcObject = camStream;
        await camVideo.play();

        // 5. Canvas setup
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = 1920;
        canvas.height = 1080;
        ctx.imageSmoothingEnabled = false;

        const draw = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            if (screenVideo.readyState >= 2) {
                ctx.drawImage(screenVideo, 0, 0, canvas.width, canvas.height);
            }
            if (camVideoTrackRef.current?.enabled && camVideo.readyState >= 2) {
                ctx.drawImage(
                    camVideo,
                    canvas.width - cameraSize.width - cameraPosition.x,
                    canvas.height - cameraSize.height - cameraPosition.y,
                    cameraSize.width,
                    cameraSize.height
                );
            }
            requestAnimationFrame(draw);
        };
        draw();

        // 6. Mix audio (tab + boosted mic)
        const mixedAudioStream = mixAudioStreams([screenStream, boostedMicStream]);

        // 7. Final output stream
        const canvasStream = canvas.captureStream(30);
        const finalStream = new MediaStream([
            ...canvasStream.getVideoTracks(),
            ...mixedAudioStream.getAudioTracks()
        ]);

        // 8. WebRTC setup
        const pc = new RTCPeerConnection();

        finalStream.getTracks().forEach(track => {
            const sender = pc.addTrack(track, finalStream);
            if (track.kind === 'video') {
                const params = sender.getParameters();
                if (!params.encodings) params.encodings = [{}];
                params.encodings[0].maxBitrate = 5000 * 1000;
                sender.setParameters(params).catch(console.warn);
            }
        });

        // 9. VP9 codec patch
        const offer = await pc.createOffer();
        let modifiedSDP = offer.sdp;

        modifiedSDP = modifiedSDP.replace(/m=video (\d+) [\w/]+ (.*)\r\n/, (line, port, codecs) => {
            const codecList = codecs.split(' ');
            const vp9Payload = codecList.find(pt =>
                modifiedSDP.includes(`a=rtpmap:${pt} VP9/90000`)
            );
            if (vp9Payload) {
                const reordered = [vp9Payload, ...codecList.filter(pt => pt !== vp9Payload)];
                return `m=video ${port} UDP/TLS/RTP/SAVPF ${reordered.join(' ')}\r\n`;
            }
            return line;
        });

        await pc.setLocalDescription({type: 'offer', sdp: modifiedSDP});

        // 10. Send to Millicast
        const publishRes = await fetch(`https://director.millicast.com/api/whip/${streamName}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${jwt}`,
                'Content-Type': 'application/sdp'
            },
            body: modifiedSDP
        });

        const answer = await publishRes.text();
        await pc.setRemoteDescription({type: 'answer', sdp: answer});

        console.log('✅ Live with stream:', streamName);
        checkIfVP9InUse(pc);
    };


    const stopStream = async () => {
        screenStreamRef.current?.getTracks().forEach(track => track.stop());
        micStreamRef.current?.getTracks().forEach(track => track.stop());
        camStreamRef.current?.getTracks().forEach(track => track.stop());

        pcRef.current?.close();

        if (streamName) {
            console.log('SHOULD INFORM API')

            associateServices.killStream({name: streamName}).then(null)
        }

        setIsStreaming(false);
        setStreamName(null);
        setIsProcessing(false)


        store.dispatch(AUTHENTICATION_ACTIONS.setStreamID(null))
        broadcastReduxState('activeStreamID', null);

    };

    const toggleCamera = () => {
        if (camVideoTrackRef.current) {
            camVideoTrackRef.current.enabled = !camVideoTrackRef.current.enabled;
            setCameraEnabled(camVideoTrackRef.current.enabled);
        }
    };

    const toggleMic = () => {
        if (micAudioTrackRef.current) {
            micAudioTrackRef.current.enabled = !micAudioTrackRef.current.enabled;
            setCameraMicEnabled(micAudioTrackRef.current.enabled); // or setMicEnabled
        }
    };

    const toggleTabAudio = () => {
        if (tabAudioTrackRef.current) {
            tabAudioTrackRef.current.enabled = !tabAudioTrackRef.current.enabled;
            setTabAudioEnabled(tabAudioTrackRef.current.enabled);
        }
    };

    useEffect(() => {
        if (!isStreaming || !streamName) return;

        associateServices.pingStream({
            name: streamName
        }).then(null)

        const interval = setInterval(() => {
            associateServices.pingStream({
                name: streamName
            }).then(null)

        }, 15000); // every 15 seconds

        return () => clearInterval(interval);
    }, [isStreaming, streamName]);

    return (

        <>
            {
                isStreaming &&
                <>
                    <button
                        onClick={() => !isStreaming ? startStream() : stopStream()}
                        // disabled={isStreaming}
                        style={{marginTop: 10, padding: '10px 20px', fontWeight: 'bold', color: '#FFF'}}
                    >
                        {isStreaming ? '🟢 Stop Streaming...' : 'Start Streaming'}
                    </button>

                    {
                        isStreaming && <div className={'row gap-2 justify-content-around'}>

                            <button onClick={toggleCamera} className={'text-white col-auto'}>
                                {cameraEnabled ? 'Turn Off Camera' : 'Turn On Camera'}
                            </button>

                            <button onClick={toggleMic} className={'text-white col-auto'}>
                                {cameraMicEnabled ? 'Mute Mic' : 'Unmute Mic'}
                            </button>

                            <button onClick={toggleTabAudio} className={'text-white col-auto'}>
                                {tabAudioEnabled ? 'Mute Game Sound' : 'Unmute Game Sound'}
                            </button>

                        </div>
                    }


                    <div className="container">
                        <canvas ref={canvasRef} width={1920} height={1080} style={{display: 'none'}}/>
                    </div>

                </>
            }

            <header id={"header"} className="header header--logged">


                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="header__content">

                                <Link
                                    to={stringHelper.getLocalizedPath(currentLanguage, '/')}

                                    className="header__logo"/>

                                <div className="header__search">
                                    <button className="header__search-btn" type="button">
                                        {t('general.search')}
                                        <SvgIcon id={'search'}/></button>
                                </div>


                                <div className="header__actions">
                                    <button className="header__search-btnmob" type="button">
                                        <SvgIcon id={'search'}/>
                                    </button>


                                    {
                                        authenticated ?
                                            <>

                                                {
                                                    !agent?.isMobile && user?.is_streamer &&
                                                    <>
                                                        <Tooltip anchorSelect={`#start-streaming`}
                                                                 className="tooltip-me">
                                                        <span className="gap-2">
                                                            {t('streams.start-streaming')}
                                                        </span>
                                                        </Tooltip>

                                                        <a onClick={startStream} className={'active'}
                                                           id={'start-streaming'}>
                                                            <SvgIcon id={'stream'}/>
                                                        </a>
                                                    </>
                                                }


                                                <>
                                                    {
                                                        correction?.id && <>
                                                            <Link
                                                                to={stringHelper.getModalPathWithTab('vip', 'correction', searchParams)}
                                                                // to={stringHelper.getLocalizedPath(currentLanguage, `?modal=vip&tab=correction`)}
                                                                id="correction-button"
                                                                className="correction-button"
                                                                style={{
                                                                    '--border-width': `${correction.percentage}%`
                                                                }}
                                                            >

                                                                {t('modals.vip.tabs.correction')}

                                                                <span className="small">
                                                                    {`(${correction.percentage}%)`}
                                                                </span>
                                                            </Link>
                                                        </>
                                                    }
                                                </>

                                                <div className="header__wallet">
                                                    <div className="dropdown header__wallet-dropdown">
                                                        <button
                                                            className="header__wallet-dropdown-btn"
                                                            type="button"
                                                            id="dropdownWalet"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <div>
                                                                <InstrumentIcon code={selectedWallet?.code}/>
                                                                {
                                                                    inPlay ? t('header.in-play') :
                                                                        selectedFiat ? symbols[selectedFiat] + Big(selectedWallet?.balance || 0).div(fiatRates[selectedWallet?.code] || 1).toFixed(2) :
                                                                            Big(selectedWallet?.balance || 0).toFixed(selectedWallet?.code === 'TRY' || selectedWallet?.code === 'TRY' ? 2 : 8)
                                                                }
                                                            </div>

                                                            <SvgIcon id={'right-down'}/>
                                                        </button>

                                                        <div className="dropdown-menu header__wallet-menu"
                                                             aria-labelledby="dropdownWalet">
                                                            <div className="header__wallet-search">
                                                                <div className="search">
                                                                    <input
                                                                        name="search"
                                                                        value={search}
                                                                        onChange={e => setSearch(e.target.value)}
                                                                        type="text"
                                                                        className="search__input"
                                                                        placeholder={t('header.search-currencies')}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <ul className="header__wallet-currencies">
                                                                {
                                                                    filteredCurrencyList?.map(headerWalletItem => (
                                                                        <li
                                                                            onClick={e => {
                                                                                localStorage.setItem('wallet', headerWalletItem?.code);
                                                                                store.dispatch(AUTHENTICATION_ACTIONS.setActiveWallet(headerWalletItem))
                                                                            }}
                                                                            key={headerWalletItem?.code}>
                                                                          <span>
                                                                              <InstrumentIcon
                                                                                  code={headerWalletItem?.code}/>
                                                                              {headerWalletItem?.code}
                                                                          </span>{" "}
                                                                            {/*<span>{Big(headerWalletItem?.balance || 0).toFixed(8)}</span>*/}
                                                                            <span>

                                                                               {
                                                                                   selectedFiat ? symbols[selectedFiat] + Big(headerWalletItem?.balance || 0).div(fiatRates[headerWalletItem?.code] || 1).toFixed(2) :
                                                                                       Big(headerWalletItem?.balance || 0).toFixed(headerWalletItem?.code === 'TRY' || headerWalletItem?.code === 'USDT' ? 2 : 8)
                                                                               }

                                                                        </span>
                                                                        </li>

                                                                    ))
                                                                }

                                                            </ul>
                                                            <Link
                                                                to={stringHelper.getModalPath('wallet-settings', searchParams)}
                                                                className="header__dropdown-btn gap-2" type="button">
                                                                <SvgIcon id={'wallet'}/>
                                                                <span>
                                                                    {t('header.wallet-settings')}
                                                                </span>
                                                            </Link>


                                                            {
                                                                configuration?.unify_balances_enabled &&
                                                                <Link
                                                                    to={stringHelper.getModalPath('unify-balances', searchParams)}
                                                                    className="header__dropdown-btn gap-2"
                                                                    type="button">
                                                                    <SvgIcon id={'unify-balances'}/>
                                                                    <span>
                                                                            {t('unify-balances.title')}
                                                                        </span>
                                                                </Link>
                                                            }

                                                        </div>
                                                    </div>
                                                    <Link
                                                        className="header__wallet-btn cursor-pointer"
                                                        to={stringHelper.getModalPath('wallet', searchParams)}
                                                    >
                                                        <SvgIcon id={'wallet'}/>
                                                    </Link>
                                                </div>

                                                {
                                                    !agent?.isMobile && configuration?.wheel_able &&
                                                    <button
                                                        className="header__action"
                                                        type="button"
                                                        onClick={handleWheel}
                                                    >
                                                        <WheelIcon/>

                                                    </button>
                                                }

                                                <div className="dropdown header__dropdown">


                                                    {
                                                        !agent?.isMobile &&
                                                        <Tooltip anchorSelect={`#dropdownNotifications`}
                                                                 className="tooltip-me">

                                                        <span className="gap-2">
                                                            {t('header.notifications')}
                                                        </span>
                                                        </Tooltip>
                                                    }


                                                    <button
                                                        className="header__action"
                                                        type="button"
                                                        id="dropdownNotifications"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <SvgIcon
                                                            id={'notifications'}/>

                                                        {
                                                            hasUnreadNotifications?.notifications >= 1 || hasUnreadNotifications?.messages >= 1 ?
                                                                <div className="notification-counter">
                                                                    {/*<span>{hasUnreadNotifications?.messages + hasUnreadNotifications?.notifications}</span>*/}
                                                                </div> : null
                                                        }

                                                    </button>

                                                    <Notifications
                                                        handleReFetchNotifications={handleReFetchNotifications}
                                                        hasUnreadNotifications={hasUnreadNotifications}
                                                    />
                                                </div>


                                                {
                                                    !agent?.isMobile &&
                                                    <Tooltip anchorSelect={`#dropdownUser`} className="tooltip-me">
                                                    <span className="gap-2">
                                                        {t('sidebar.profile')}
                                                    </span>
                                                    </Tooltip>
                                                }

                                                <div className="dropdown header__dropdown">
                                                    <button className="header__action" type="button"
                                                            id="dropdownUser"
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                        <SvgIcon id={'profile'}/>

                                                    </button>

                                                    <ul
                                                        className="dropdown-menu dropdown-menu-end header__user-menu"
                                                        aria-labelledby="dropdownUser">


                                                        <li>
                                                            <Link type="button"
                                                                  to={stringHelper.getModalPath('wallet', searchParams)}
                                                            >
                                                                <SvgIcon id={'wallet'}/>

                                                                <span>
                                                                {t('header.wallet')}
                                                            </span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link type="button"
                                                                  to={stringHelper.getModalPath('vault', searchParams)}
                                                            >
                                                                <SvgIcon id={'vault'}/>

                                                                <span>
                                                                {t('header.vault')}
                                                            </span>
                                                            </Link>
                                                        </li>

                                                        <li>
                                                            <Link
                                                                to={stringHelper.getModalPathWithTab('vip', 'bonus-code', searchParams)}
                                                            >
                                                                <SvgIcon extra={'mini-icon'} id={'giftbox'}/>
                                                                {t('modals.vip.tabs.bonus-code')}
                                                            </Link>
                                                        </li>


                                                        {
                                                            configuration?.discount_able &&
                                                            <li>
                                                                <a onClick={handleDiscountCheck}>
                                                                    <SvgIcon extra={'mini-icon'} id={'discount'}/>
                                                                    {t('general.request-discount')}
                                                                </a>
                                                            </li>

                                                        }


                                                        <li>
                                                            <Link
                                                                to={stringHelper.getModalPath('vip', searchParams)}
                                                            >
                                                                <SvgIcon id={'vip-club'}/>
                                                                {t('header.vip')}
                                                            </Link>
                                                        </li>

                                                        <li>
                                                            <Link
                                                                to={stringHelper.getModalPathStatistics('statistics', '', searchParams)}
                                                            >
                                                                <SvgIcon id={'statistics'}/>
                                                                {t('header.statistics')}
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to={stringHelper.getLocalizedPath(currentLanguage, '/settings')}
                                                            >
                                                                <SvgIcon id={'user-settings'}/>
                                                                {t('header.settings')}

                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to={stringHelper.getLocalizedPath(currentLanguage, '/transactions')}
                                                            >
                                                                <SvgIcon id={'transactions'}/>
                                                                {t('header.transactions')}
                                                            </Link>
                                                        </li>


                                                        <li>
                                                            <Link
                                                                to={stringHelper.getLocalizedPath(currentLanguage, '/affiliate')}
                                                            >
                                                                <SvgIcon id={'affiliate'}/>
                                                                {t('header.affiliate')}
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <button onClick={handleLiveSupport}>
                                                                <SvgIcon id={'head-set'}/>
                                                                {t('header.live-support')}
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to={stringHelper.getLocalizedPath(currentLanguage, '/policy')}
                                                            >
                                                                <SvgIcon id={'privacy'}/>
                                                                {t('header.privacy')}

                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <button onClick={handleLogout}>
                                                                <SvgIcon id={'logout'}/>
                                                                <span>
                                                                {t('header.logout')}
                                                            </span>

                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </>
                                            :
                                            <>
                                                <button
                                                    className="header__signin"
                                                    type="button"
                                                    onClick={handleLogin}
                                                >
                                                    <SvgIcon id={'login'}/>
                                                    <span>{t('header.login')}</span>
                                                </button>
                                                <button
                                                    onClick={handleRegister}
                                                    className="header__signup"
                                                    type="button"
                                                >
                                                    {t('header.register')}
                                                </button>
                                            </>
                                    }


                                    {
                                        configuration?.chat_able && !agent?.isMobile &&

                                        <Tooltip anchorSelect={`#chatSidebar`} className="tooltip-me">
                                                    <span className="gap-2">
                                                        {t('lowbar.chat')}
                                                    </span>
                                        </Tooltip>
                                    }

                                    {
                                        configuration?.chat_able && authenticated &&
                                        <div className="dropdown header__dropdown">
                                            <button id="chatSidebar" className="header__chat " type="button">
                                                <SvgIcon id={'chat'}/>
                                            </button>
                                        </div>
                                    }


                                    {
                                        !agent?.isMobile && configuration?.stream_enabled &&

                                        <Tooltip anchorSelect={`#streamSidebar`} className="tooltip-me">
                                                 <span className="gap-2">
                                                        Stream
                                                    </span>


                                        </Tooltip>
                                    }

                                    {/*{*/}
                                    {/*    authenticated && configuration?.stream_enabled &&*/}
                                    {/*    <div className="dropdown header__dropdown" onClick={handleCheckStream}>*/}
                                    {/*        <button id="streamSidebar" className="header__stream" type="button">*/}

                                    {/*            <SvgIcon id={streamChecking ? 'loading-svg' : 'stream-1'}/>*/}
                                    {/*        </button>*/}
                                    {/*    </div>*/}
                                    {/*}*/}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </header>
        </>
    )


}


export default React.memo(Header)
